<template>
  <div class="input-text">
    <input
      type="text"
      :placeholder="placeholder"
      :value="selected"
      @input="updateValue($event.target.value)"
    />
  </div>
</template>

<script>
export default {
  name: 'InputText',
  props: {
    placeholder: String,
  },
  data () {
    return {
      selected: '',
    };
  },
  methods: {
    updateValue (value) {
      this.selected = value;
      this.$emit('update:modelValue', value); // Emit the new value
    }
  }
};
</script>

<style scoped>
.input-text input {
  @apply border p-1.5 w-full focus:outline-none focus:ring-0 focus:border-gray-300;
}
</style>
